import { useTranslation } from 'react-i18next';
import circleCheck from '@/enterprise/assets/circlecheck.svg?url';

interface DoneStepProps {
  body?: string;
}

const DoneStep = ({ body }: DoneStepProps) => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col items-center gap-4">
      <img src={circleCheck} alt="" className="h-[70px] w-[70px]" />
      <div className="flex w-full flex-col gap-6 px-1">
        <p className="text-base text-text-primary">{body ?? t('plaid.modal.done.body')}</p>
      </div>
    </div>
  );
};

export default DoneStep;
